// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sputnik__AddAuthorizedSignerBanner__uDwvv .Icon-payroll{color:var(--tri-color-icon-info)}`, "",{"version":3,"sources":["webpack://./src/pages/CreditApplicationPages/PeopleInfoForm/CompanyOwnerSection/AddAuthorizedSignerBanner/styles.module.scss"],"names":[],"mappings":"AACE,yDACE,gCAAA","sourcesContent":[".AddAuthorizedSignerBanner {\n  :global(.Icon-payroll) {\n    color: var(--tri-color-icon-info)\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"AddAuthorizedSignerBanner": `sputnik__AddAuthorizedSignerBanner__uDwvv`
};
export default ___CSS_LOADER_EXPORT___;
